<div id="head">
    <div id="pic&title">
        <img id="mypic" src="https://alonzoaustin.com/mypic.png" />
        <div id="mydescription">
            <h1>Alonzo Austin</h1>
            <h3>Fullstack Web Developer</h3>
            <p style="font-size: small;">Hello, I am looking for a new opportunity to help develop/maintain/debug your next web app</p>
            <h3>(727) 687-0625</h3>
            <h3>alonzo6546@outlook.com</h3>
        </div>
    </div>
    <div id="skillsDiv">
        <div id="skills" *ngFor="let project of projects">
            <p class="tags" *ngFor="let category of project.categories">{{category}}</p>
        </div>
    </div>
</div>

<h1 id="projectHeader">Projects</h1>
<hr>

<div class="card">
        <div  *ngFor="let project of projects; let i = index" class="portfolioProp">
            <a routerLink="/project/{{projectIdList[i]}}">
                <img class="showcaseImage" src={{project.showcaseImage}} />
            </a>
            <br>
            <br>
            <div class="project">
                <a routerLink="/project/{{projectIdList[i]}}">
                    <div class="title">
                        <strong>{{project.title}}</strong>
                    </div>
                </a>
                <br>
                <div class="description">
                    <strong>{{project.description}}</strong>
                </div>
                <br>
                <div class="tagDiv">
                    <p class="tags" *ngFor="let category of project.categories">{{category}}</p>
                </div>
            </div>
        </div>
</div>
<br>
